import { BaseEntity } from '@/api/EntityApi';
import { Store } from '@/api/StoreApi';

export enum UserStatus {
	INACTIVE = 'INACTIVE',
	ACTIVE = 'ACTIVE',
	SUSPENDED = 'SUSPENDED',
}

export enum UserType {
	ADMIN = 'admin',
	USER = 'user',
}

interface BaseUser extends BaseEntity {
	email: string;
	firstName: string;
	lastName: string;
	password: string;
	status: UserStatus;
	userType: UserType;
}

export interface Admin extends BaseUser {
	userType: UserType.ADMIN;
}

export interface User extends BaseUser {
	phoneNumber: string;
	companyName: string;
	city: string;
	country: string;
	street: string;
	postalCode: string;
	houseNumber: string;
	vatNumber: string;
	store: Store;
	userType: UserType.USER;
}

export type AppUser = Admin | User;
